import {
  getListFeedback,
  updateFeedback,
  createFeedback,
  deleteFeedback,
} from "../api/customerFeedback";
const customerFeedback = {
  state: {},
  reducers: {},
  effects: (dispatch) => ({
    getListFeedback(payload, rootState) {
      return getListFeedback(payload);
    },
    updateFeedback(payload, rootState) {
      const { id, data } = payload;
      return updateFeedback(id, data);
    },
    createFeedback(payload, rootState) {
      return createFeedback(payload);
    },
    deleteFeedback(payload, rootState) {
      return deleteFeedback(payload);
    },
  }),
};

export default customerFeedback;
